export const damageAssets = {
  name: `damageAssets`,
  sql: `
    SELECT cartodb_id, the_geom_webmercator, lyr_sub, lyr_subwp, cost, contentcos, i100cost, i100cont, i500cost, i500cont, ieq1econ, ieq2econ, mun, fldbln, eqbln
    FROM solano_hazus_carto_results_x_mun WHERE name not like 'P%'
  `,
  cartoCSS: `
    #layer {
      marker-width: 13;
      marker-fill: #d56b00;
      marker-width: ramp([cost], range(2, 25), quantiles(4));
      marker-fill: ramp([cost], (#c6a87c, #F1F1F1, #b5dda9, #149d05), quantiles(4));
      marker-fill-opacity: 0.92;
      marker-allow-overlap: true;
      marker-line-width: 1;
      marker-line-color: #000000;
      marker-line-opacity: 1;
      marker-comp-op: src-over;
    }  
  `,
  featureOverColumns: [
    "lyr_sub",
    "lyr_subwp",
    "cost",
    "contentcos",
    "i100cost",
    "i100cont",
    "i500cost",
    "i500cont",
    "ieq1econ",
    "ieq2econ",
    "mun",
  ]
}

export const damageAssetsCategories = {
  name: `damageAssetsCategories`,
  type: 'Category',
  source: damageAssets.sql,
  field: 'mun',
  options: {
    limit: 100,
    operation: 'SUM',
    operationColumn: 'cost'
  }
}

export const damageAssetsEQ1 = {
  name: `damageAssetsEQ1`,
  type: 'Formula',
  source: damageAssets.sql,
  field: 'ieq1econ',
  options: {
    operation: 'SUM',
  }
}

export const damageAssetsEQ2 = {
  name: `damageAssetsEQ2`,
  type: 'Formula',
  source: damageAssets.sql,
  field: 'ieq2econ',
  options: {
    operation: 'SUM',
  }
}

export const damageAssetsI100costlo = {
  name: `damageAssetsI100costlo`,
  type: 'Formula',
  source: damageAssets.sql,
  field: 'i100cost',
  options: {
    operation: 'SUM',
  }
}

export const damageAssetsI100conten = {
  name: `damageAssetsI100conten`,
  type: 'Formula',
  source: damageAssets.sql,
  field: 'i100cont',
  options: {
    operation: 'SUM',
  }
}

export const damageAssetsI500costlo = {
  name: `damageAssetsI500costlo`,
  type: 'Formula',
  source: damageAssets.sql,
  field: 'i500cost',
  options: {
    operation: 'SUM',
  }
}

export const damageAssetsI500conten = {
  name: `damageAssetsI500conten`,
  type: 'Formula',
  source: damageAssets.sql,
  field: 'i500cont',
  options: {
    operation: 'SUM',
  }
}